import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white py-8">
      <div className="container mx-auto px-6 text-center text-slate-500">
        <p>&copy; 2024 Sveva Falanga. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 